module.exports = __webpack_public_path__ + "static/media/sad.37bbf1f9.svg";